<template>
    <div class="my-dou-data">
        <!-- 用户信息 -->
        <div class="my-dou-data_user">
            <img src="@/assets/images/training-logo.png" alt="" />

            <div class="user-info">
                <div class="user-info_label">一课教育</div>

                <div class="user-info_certifica">
                    <i class="iconfont">&#xe62b;</i>
                    {{ data_type === 15 ? "个人认证" : "企业认证" }}
                </div>
            </div>
        </div>

        <!-- 提示 -->
        <div class="my-dou-data_tip">
            <i class="el-icon-warning"></i>

            <span>近期开始治理证件到期情况，请关注平台通知</span>
        </div>

        <!-- 常用菜单 -->
        <div class="my-dou-data_menu">
            <div class="item-header">常用功能</div>

            <div class="menu-list">
                <div class="menu-item" v-for="(menuItem, index) in menuOptions" :key="index">
                    <i class="iconfont">{{ formatIconfont(menuItem.icon) }}</i>

                    <span>{{ menuItem.label }}</span>
                </div>
            </div>
        </div>

        <!-- 成长伙伴 -->
        <div class="my-dou-data_grow">
            <div class="item-header">
                <div>成长伙伴</div>

                <div class="header-more">查看更多></div>
            </div>

            <div class="grow-box">
                <i class="iconfont">&#xe9cf;</i>

                <div class="grow-box_label">恭喜你，已完成全部任务</div>

                <div class="grow-box_more">更多优质任务敬请期待</div>
            </div>
        </div>

        <!-- DOU+学堂 -->
        <div class="my-dou-data_study">
            <div class="item-header">
                <div>DOU+学堂</div>

                <div class="header-more">更多投放小知识></div>
            </div>
        </div>

        <!-- 账号洞察 -->
        <!-- <div class="my-dou-data_account">
            <div class="item-header">
                <div class="header-label">
                    账号洞察

                    <span>近7日 <i class="el-icon-arrow-down"></i></span>
                </div>

                <div class="header-more">
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>

            <div class="account-box">
                <div class="account-item" v-for="(item, index) in accountLabels" :key="index">
                    <div class="item-label">{{ item }}</div>
                    <div class="item-num">0</div>
                    <div class="item-trend">持平</div>
                </div>
            </div>
        </div> -->

        <!-- 我的资产 -->
        <div class="my-dou-data_money">
            <div class="item-header">
                <div class="header-label">
                    <span>我的资产</span>

                    <i class="iconfont">&#xe603;</i>
                </div>

                <div class="header-more">
                    <div class="more-button">充值</div>
                </div>
            </div>

            <div class="money-box">
                <div class="money-item" v-for="(item, index) in moneyLabels" :key="index">
                    <div class="item-label">
                        {{ item }}
                        <i class="el-icon-arrow-right"></i>
                    </div>

                    <div class="item-num">0</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MyDouData",
    data() {
        return {
            menuOptions: [
                // { label: "账号速推", icon: "&#xe62d;" },
                { label: "退款", icon: "&#xe66b;" },
                { label: "账号信息", icon: "&#xe6be;" },
                { label: "发票", icon: "&#xe6ed;" },
                { label: "用户帮助", icon: "&#xe63f;" },
                { label: "通知管理", icon: "&#xe7f8;" },
                { label: "数据授权", icon: "&#xe61b;" },
                { label: "兑换收入", icon: "&#xe6dd;" },

                // { label: "线索管理", icon: "&#xe672;" },
                // { label: "批量投放", icon: "&#xe657;" },
            ],
            accountLabels: ["消耗", "播放量", "粉丝量", "互动量"],
            moneyLabels: ["总余额", "现金余额", "赠款余额", "优惠券"],
            data_type: Number(this.$route.query.data_type),
        };
    },
    methods: {
        // 将iconfont字符串转化为unicode
        formatIconfont(icon) {
            const reg = new RegExp(/(&#x)?(.*)/);
            let iconfontName = "";
            if (reg.test(icon)) {
                iconfontName = reg.exec(icon)[2];
            }

            return String.fromCharCode(parseInt(iconfontName, 16));
        },
    },
};
</script>

<style lang="scss" scoped>
.my-dou-data {
    width: 100%;
    background: linear-gradient(to bottom, #fde9eb, #f7f7f7);
    box-sizing: border-box;
    padding: 50px 12px 20px 12px;

    & > * {
        box-sizing: border-box;
    }

    &_user {
        display: flex;
        gap: 10px;
        padding-left: 10px;

        img {
            width: 64px;
            height: 64px;
            border-radius: 50%;
            object-fit: cover;
            background-color: #ffffff;
        }

        .user-info {
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            &_label {
                font-family: PingFang-SC;
                font-size: 20px;
                color: #333333;
            }

            &_certifica {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 2px;
                background: linear-gradient(to right, #e5c68f, #f6e0b8);
                padding: 4px 12px;
                font-size: 14px;
                border-radius: 20px;
                color: #513825;

                i {
                    font-size: 15px;
                }
            }
        }
    }

    &_tip {
        padding: 6px;
        border-radius: 10px;
        background-color: #ffffff;
        margin-top: 10px;
        color: #d6a63d;
        font-size: 13px;

        i {
            margin-right: 2px;
        }
    }

    &_menu,
    &_grow,
    &_study,
    &_account,
    &_money {
        padding: 16px;
        background-color: #ffffff;
        border-radius: 10px;
        margin-top: 10px;

        .item-header {
            font-size: 16px;
            color: #323233;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .header-more {
                font-size: 14px;
                color: #999999;
                cursor: pointer;
            }
        }
    }

    &_menu {
        .menu-list {
            display: flex;
            flex-wrap: wrap;

            .menu-item {
                width: calc(100% / 4);
                height: 70px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                gap: 2px;
                flex-shrink: 0;
                color: #323233;
                cursor: pointer;

                .iconfont {
                    font-size: 26px;
                }

                span {
                    font-size: 12px;
                }
            }
        }
    }

    &_grow {
        .grow-box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
            padding-top: 10px;
            padding-bottom: 10px;

            .iconfont {
                font-size: 80px;
                color: #dddee0;
            }

            &_label {
                color: #323233;
                font-size: 14px;
            }

            &_more {
                font-size: 12px;
                color: #999999;
            }
        }
    }

    &_study {
    }

    &_account {
        .item-header {
            .header-label {
                display: flex;
                align-items: center;
                gap: 10px;

                span {
                    font-size: 12px;
                }
            }

            .header-more {
                font-size: 18px;
            }
        }

        .account-box {
            display: flex;

            .account-item {
                width: calc(100% / 4);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 6px;
                margin-top: 20px;
                padding-bottom: 10px;

                .item-label {
                    color: #666666;
                    font-size: 14px;
                }

                .item-num {
                    color: #333333;
                    font-size: 20px;
                    font-weight: 600;
                    line-height: 20px;
                }

                .item-trend {
                    color: #999999;
                    font-size: 14px;
                }
            }
        }
    }

    &_money {
        .item-header {
            .header-label {
                display: flex;
                align-items: center;
                gap: 2px;

                .iconfont {
                    font-size: 14px;
                    line-height: 14px;
                    margin-top: 2px;
                }
            }

            .more-button {
                background-color: #fc2b55;
                font-size: 12px;
                padding: 6px 16px;
                border-radius: 20px;
                color: #ffffff;
                cursor: pointer;
            }
        }

        .money-box {
            display: flex;

            .money-item {
                width: calc(100% / 4);
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 6px;
                margin-top: 20px;
                padding-bottom: 10px;

                .item-label {
                    color: #666666;
                    font-size: 12px;
                }

                .item-num {
                    color: #333333;
                    font-size: 20px;
                    font-weight: 600;
                    line-height: 20px;
                }
            }
        }
    }
}
</style>
